const BACKEND_URL = process.env.REACT_APP_BASE_URL || "";

export const uploadPaths = {
  profilePicture: (filename: string) =>
    `${BACKEND_URL}/uploads/userPictures/${filename}`,
  companyLogo: (filename: string) => `${BACKEND_URL}/uploads/companyLogos/${filename}`,
  productImage: (filename: string) =>
    `${BACKEND_URL}/uploads/productImages/${filename}`,
  qrCode: (filename: string) => `${BACKEND_URL}/uploads/qrcodes/${filename}`,
};
